import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/htx/comorbidities/geneticistOpinion";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	geneticistOpinion: {
		id: "form.geneticist_opinion",
		defaultMessage: "Genetika"
	},
	value: {
		id: "form.geneticist_opinion.value",
		defaultMessage: "Szakvizsgálat történt?"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["result"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "geneticistOpinion",
	value: {
		title: messages.geneticistOpinion,
		validator,
		fieldset
	}
};
